module.exports = __webpack_public_path__ + "static/media/ownExamHistory.15d25241.png";